module.exports = __webpack_public_path__ + "img/dl-mac-sr-setting.70115bc4.png";